export const dropProps = <T extends object, TProps extends keyof T>(
	obj: T,
	props: TProps[],
): Omit<T, TProps> => {
	const newObj = { ...obj };
	props.forEach((prop) => delete newObj[prop]);
	return newObj;
};
